import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";

import LTIAppLaunch from "./routes/LTIAppLaunch";

export default store => ({
  path: "home",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "home" */ "./components/Home"),
      import(/* webpackChunkName: "home" */ "./modules/HomeModule"),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;

      if (reducer) {
        injectReducer(store, {
          key: "home",
          reducer,
        });
      }

      return component;
    })
  ),
  childRoutes: [LTIAppLaunch(store)],
});
